import React, { Fragment, useState, useLayoutEffect, useContext, useEffect, forwardRef } from "react";
import { Col } from "reactstrap";
import { Menu } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";

const Leftbar = forwardRef((props, ref) => {
  const { setToggleIcon, toggleSidebar, toggleIcon } = useContext(CustomizerContext);
  const [sidebartoggle, setSidebartoggle] = useState(toggleIcon);
  const width = useWindowSize();

  function useWindowSize() {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
          setToggleIcon(true);
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size[0];
  }

  const responsive_openCloseSidebar = () => {
    toggleSidebar(!sidebartoggle);
  };

  useEffect(() => {
    if (width <= 991) {
      setToggleIcon(true);
      setSidebartoggle(false);
    } else {
      setToggleIcon(false);
      setSidebartoggle(true);
    }
  }, [width, setToggleIcon]);

  return (
    <Fragment>
      <Col className="header-logo-wrapper header-left col-auto p-0" id="out_side_click">
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: `${require("../../../assets/images/logo/logo.png")}`,
                alt: "",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: `${require("../../../assets/images/logo/logo_dark.png")}`,
                alt: "",
              }}
            />
          </Link>
        </div>
        <div className="toggle-sidebar" onClick={responsive_openCloseSidebar}>
          <Menu />
        </div>
      </Col>
      {/* {userData?.role === 'user' && (
        <Col xxl="5" xl="6" lg="5" md="4" sm="3" className="left-header p-0">
          <NotificationSlider userData={userData} />
        </Col>
      )} */}
    </Fragment>
  );
});

export default Leftbar;